import type { IGuest_Invitation } from '@bridebook/models/source/models/Weddings/Guests.types';
import { Rsvp } from '@bridebook/models/source/models/Weddings/Guests.types';

export type GuestRsvpStatus = 'pending' | 'responded' | 'noInvitation';

export const getGuestRsvpStatus = (invitation: IGuest_Invitation | undefined): GuestRsvpStatus => {
  const events = invitation?.events;
  if (!events || Object.keys(events).length === 0) return 'noInvitation';
  return Object.values(events).every((event) => event.rsvp !== Rsvp.PENDING)
    ? 'responded'
    : 'pending';
};

const SORT_PRIORITY: Record<GuestRsvpStatus, number> = {
  pending: 0,
  responded: 1,
  noInvitation: 2,
};

export const sortRelatedGuests = <T extends { invitation?: IGuest_Invitation }>(
  members: T[],
): T[] =>
  [...members].sort(
    (a, b) =>
      SORT_PRIORITY[getGuestRsvpStatus(a.invitation)] -
      SORT_PRIORITY[getGuestRsvpStatus(b.invitation)],
  );
